export const cleanParams = <T extends Record<string, any>>(obj: T): Partial<T> => {
  const out: Record<string, any> = {};
  for (const [k, v] of Object.entries(obj)) {
    const isEmptyString = typeof v === "string" && v.trim() === "";
    const isEmptyArray = Array.isArray(v) && v.length === 0;
    const isNil = v === undefined || v === null;
    if (!isNil && !isEmptyString && !isEmptyArray) out[k] = v;
  }
  return out as Partial<T>;
};

export const makeQuery = (q: Record<string, string | number | null | undefined>): string => {
  const usp = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v === null || v === undefined) continue;
    if (typeof v === "string" && v.trim() === "") continue;
    usp.append(k, String(v));
  }
  const s = usp.toString();
  return s ? `?${s}` : "";
};
